/*
 * @Author: bbqin
 * @Date: 2021-09-06 09:53:44
 * @LastEditTime: 2022-08-24 15:40:16
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\api\routerrender.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from 'react';
import ReactDom from 'react-dom';
import { HashRouter as Router, Switch, Route, MemoryRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { getMicroContext, setInsideAppCode, addEventListener } from './qiankunContext';
import{ getGlobalStorage } from './storage';
import { getTopWindow } from './window';
//import { store } from './store';

import { routerExtend } from '../FastExtend';
import ViewModel from './viewmodel';

const RouteWithSubRoutes = route => (
    <Route
        path={route.path}
        exact={route.exact}
        render={props => {
            if (route.component.lowcodeComponent) {

                return <route.component.lowcodeComponent {...props} routes={route.routes}/>;
            }
            return <route.component {...props} routes={route.routes} />;
        }}
    />
);

export function RenderRouter(rootElement, htmlTagid, locationInfo) {
    // 客开一下
    rootElement = (rootElement || []).concat([{
        path: '/nccextend/:extend',
        component: routerExtend,
    }]);

    ReactDom.render(
        <Router>
            <Switch>
                {rootElement.map((route, i) => {
                    return <RouteWithSubRoutes key={i} {...route} locationInfo={locationInfo} />;
                })}
            </Switch>
        </Router>,
        document.getElementById(htmlTagid),
    );
}

export function RenderRouterNext({ routes, container, component, microWindow, useRedux = false, beforeRender, isLowCode = false }) {
    if(!microWindow){
        microWindow = window;
    }
    let MicroComponent = component;
    if (microWindow.__POWERED_BY_QIANKUN__) {
        // let origin = window.location.origin;
        // let htmlPath = microWindow.__INJECTED_PUBLIC_PATH_BY_QIANKUN__.replace(origin, '');
        // let path = htmlPath.match(/nccloud\/resources\/|\/.*index\.html/)[0];
        // let newPath = path.split('/').slice(0, path.split('/').length-4).join('/');
        // let public_path = origin + newPath;

        // microWindow.__webpack_public_path__ = public_path;
        microWindow.__webpack_public_path__ = microWindow.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
    } else {
        //获取业务的 href：路径+参数
        let locationInfo = { ifr: window.location.href };
        if (typeof beforeRender == "function") {
            beforeRender({ locationInfo: locationInfo }).then(() => {
                if (routes || isLowCode) {
                    if(isLowCode){
                        let NewCom = props => {
                            return <Provider store={window.store} {...props}>
                                {<MicroComponent 
                                    {...props}  
                                    locationInfo={locationInfo}
                                />}
                            </Provider>;
                        };
                        component = NewCom;
                        routes = [{
                            path:'/',
                            component: component,
                            exact: false,
                        }];
                    }
                    //PMF();
                    RenderRouter(routes, container, locationInfo);
                } else if (MicroComponent && useRedux) {
                    ReactDom.render(<Provider store={window.store}>{<MicroComponent locationInfo={locationInfo} />}</Provider>, document.querySelector(`#${container}`));
                } else if (MicroComponent) {
                    //PMF();
                    ReactDom.render(<MicroComponent locationInfo={locationInfo} />, document.querySelector(`#${container}`));
                }
            });
        }else{
            if (routes || isLowCode) {
                //PMF();
                if(isLowCode){
                    routes = [{
                        path:'/',
                        component: <Provider store={window.store}>{<MicroComponent locationInf />}</Provider>,
                        exact: false,
                    }];
                }
                RenderRouter(routes, container);
            } else if (MicroComponent && useRedux) {
                ReactDom.render(<Provider store={window.store}>{<MicroComponent locationInfo={locationInfo} />}</Provider>, document.querySelector(`#${container}`));
            } else if (MicroComponent) {
                //PMF();
                ReactDom.render(<MicroComponent locationInfo={locationInfo} />, document.querySelector(`#${container}`));
            } 
        }
    }

    let { bootstrap, mount, unmount } = microLifeCycles({
        container: 'app',
        component: MicroComponent,
        routes,
        microWindow,
        beforeRender,
        useRedux,
    });
    return { bootstrap, mount, unmount };
}

export function setThemeClassName(dom, themeType, baseName = 'nc-lightapp-front'){
    let cls = String(dom.className);
    var replaceReg = new RegExp('' + `${baseName}-\\w+`, 'g');
    // 过下sonar
    if (cls.length > 1000) {
        return;
    }
    // 遗留主题
    cls = cls.replace(replaceReg, '');
    // 特殊要求
    cls = cls.replace('beautiful-g-transforms', '');
    cls = cls.replace('default-bg', '');
    // 直接写入 themeType  会导致 默认覆盖的 的.green样式触发
    if (themeType !== 'default' && themeType !== 'default1') {
        cls += ` ${baseName}-${themeType} beautiful-g-transforms default-bg`;
    } else {
        // default
        cls += ` ${baseName}-${themeType} default-bg`;
    }
    dom.className = cls;
}

//qiankun框架改造
function qiankunRender(container, routes, props, microWindow) {
    try {
        ReactDom.render(
            renderQiankunRouter(routes, props, microWindow),
            container,
        );
    }catch(e){
        console.log(`内部页签:${props?.runContext?.appKey}初始化报错,错误信息为:`, e);
    }
    
}
function renderQiankunRouter(routes, props, microWindow) {
    let runContext = props.runContext;
    let initialEntries = runContext.initialEntries;
    // if (!microWindow.__QIANKUN_RUNCONTEXT) {
    //     microWindow.__QIANKUN_RUNCONTEXT = { runContext: {} };
    // }
    // microWindow.__QIANKUN_RUNCONTEXT.runContext = runContext;
    // microWindow.__QIANKUN_RUNCONTEXT.runContext.globalApi = props.globalApi;
    // microWindow.__QIANKUN_RUNCONTEXT.container = props.container;
    // microWindow.__QIANKUN_RUNCONTEXT.globalEvent = props.globalEvent;

    //兼容处理不规范的url，否则需要不同领域修改库
    if(Array.isArray(initialEntries) && initialEntries[0].includes('?')){
        let item = initialEntries[0];
        if(!item.split('?')[0].startsWith('/')){
            initialEntries[0] = '/' + item;
        }
    }

    return <MemoryRouter initialEntries={initialEntries}>
        <Switch>
            {routes.map((route, i) => {
                //return <QiankunRouteWithSubRoutes key={i} { ...route }/>;
                return (
                    <Route
                        key={i}
                        path={route.path}
                        exact={route.exact}
                        render={props => {
                            runContext.history = props.history;
                            microWindow.__QIANKUN_RUNCONTEXT.runContext.history = props.history;
                            //appinfo最终可以在这里传给组件， ajax 和 pageTo里面的api直接在这里那工作台的应用编码，是否是乾坤模式在这里做判断
                            //不能再这里传，因为这里列表切换到卡片也会执行，只能从history里面获取，每次修改的时候 都修改history, 并同步sessionStorage
                            return (<route.component {...props} routes={route.routes} runContext={runContext} locationInfo={runContext.appInfo}/>);
                        }}
                    />
                );
            })}
        </Switch>
    </MemoryRouter>;
}

export function microLifeCycles({ routes, container, component, microWindow, beforeRender, useRedux }) {
    return {
        bootstrap: async function () {
        },
        mount: async function (props) {
            if(!microWindow){
                microWindow = window;
            }

            //microWindow.windowProxy = proxyWindow(microWindow, props);
            //microWindow.documentProxy = proxyDoument(document, props);
            if (!microWindow.__QIANKUN_RUNCONTEXT) {
                microWindow.__QIANKUN_RUNCONTEXT = { runContext: {} };
            }
            microWindow.__QIANKUN_RUNCONTEXT.runContext = props.runContext;
            microWindow.__QIANKUN_RUNCONTEXT.runContext.globalApi = props.globalApi;
            microWindow.__QIANKUN_RUNCONTEXT.container = props.container;
            microWindow.__QIANKUN_RUNCONTEXT.globalEvent = props.globalEvent;

            //重新设置viewModel API
            // function resetViewModel(context){
            //     const { getData: oldGetData, setData: oldSetData, setComponentState: oldSetComponentState, getComponentState: oldGetComponentState } = window.ViewModel;
            //     window.ViewModel.getData = (namespace, _runContext) => {
            //         return oldGetData(namespace, _runContext || context);
            //     };
            //     window.ViewModel.setData = (namespace, v, _runContext) => {
            //         oldSetData(namespace, v, _runContext || context);
            //     };
            //     window.ViewModel.setComponentState = (cid, namespace, v, _runContext) => {
            //         oldSetComponentState(cid, namespace, v, _runContext || context);
            //     };
            //     window.ViewModel.getComponentState = (cid, namespace, _runContext) => { 
            //         return oldGetComponentState(cid, namespace, _runContext || context);
            //     };
            //     window.viewModel = window.ViewModel;
            // }

            //切换页签的时候，需要记录上个页签的focus元素，让当前页签focus,切换回去的时候还原focus元素
            //hotkey可以设置容器么，全局生效
            // const handleVisibilityChange = function(data){
            //     if (data.visibilityState === "visible") {
            //         resetViewModel(props.runContext);
            //         // //当页签显示时，若有记录聚焦元素，则重新聚焦，否则container聚焦
            //         // if(microWindow.__focusedElement && props.container.contains(microWindow.__focusedElement)){
            //         //     microWindow.__focusedElement.focus();
            //         // }else{
            //         //     props.container.focus();
            //         // }
            //     }else{
            //         //记录当前页签隐藏时的聚焦元素
            //         //microWindow.__focusedElement = document.activeElement; 

            //     }
            // };
            //重新定义get和set为了隔离应用缓存数据
            // resetViewModel(props.runContext);
            //切换页签的时候，需要重新定义setData和getData， 因为切换回来需要重新取下当前页签的window变量
            //addEventListener('visibilitychange', handleVisibilityChange);

            setInsideAppCode(props.runContext);

            // let themeType = (window && window.nccColor) || (window && getTopWindow() && getTopWindow().nccColor) || getGlobalStorage('localStorage', 'nccColor');
            // if (themeType) {
            //     setThemeClassName(props.container, themeType);
            // }
            
            if (useRedux) {
                let MicroComponent = component;
                let NewCom = props => {
                    return <Provider store={window.store} {...props}>{<MicroComponent {...props} />}</Provider>;
                };
                component = NewCom;
            }

            if (!routes && component) {
                routes = [{
                    path:'/',
                    component: component,
                    exact: false,
                }];
            }
            
            if (typeof beforeRender == "function") {
                let locationInfo = props.runContext.appInfo;
                await beforeRender({ locationInfo: locationInfo });
            }
            //with(microWindow.windowProxy){
            qiankunRender(
                props.container ? props.container.querySelector(`#${container}`) : document.getElementById(container),
                routes,
                props,
                microWindow,
            );
            //}

        },
        unmount: async function (props) { 
            ReactDom.unmountComponentAtNode(
                props.container ? props.container.querySelector(`#${container}`) : document.getElementById(container),
            );
            //清空当前页签的缓存数据
            if(microWindow.__QIANKUN_RUNCONTEXT?.runContext){
                ViewModel.removeDataByContext(microWindow.__QIANKUN_RUNCONTEXT.runContext);
            }
            //注释清空数据，解决问题 YBP-CCF-BUG-1553、 YBP-CCF-BUG-1442
            //清空window数据 
            // microWindow.__QIANKUN_RUNCONTEXT = null;
            // microWindow = null;
            // props.container = null;
            // container = null;
           
        },
    };
}